module.exports = __webpack_public_path__ + "static/strong_yogi_site_image-089bf38d2f29bb0b950b1ee2924987b0.png";